import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ColumnDef } from './data-table/data-table.model';


@Component({
    selector: 'dropdown-dialog',
    templateUrl: 'dropdown-list-dialog.html',
    styleUrls: ['dropdown-list-dialog.css'],
    standalone: false
})

export class DropdownDialogComponent implements OnInit {
  @Output() onValueSelected: EventEmitter<any> = new EventEmitter<any>();
  rows: any[] = [];
  columns: ColumnDef[] = [{ field: 'text', header: '', type: 'template' }];
  selectedValue: string;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
  ngOnInit() {
    this.selectedValue = this.data.selected;
    var tmpData = [];
    this.data.items.forEach((el) => {
      if (el.id == null) {
        el.id = el.Text;
      }
      if (el.Text == null) {
        el.Text = el.description;
      }
      tmpData.push(el);
    });
    this.rows = tmpData;
  }

  onSelected(element) {
    this.onValueSelected.emit(element.Text);
  }
}
